<template>
        <!-- Footer -->
        <footer id="footer">
            <div class="footer-content">
                <div class="container">
					
					<div class="row mb-7">
						
						<div class="social-icons social-icons-large social-icons-colored mx-auto text-center">
                            <ul>
                                
                                <li class="social-facebook p-20"><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                
								
                                <li class="social-linkedin p-20"><a href="#"><i class="fab fa-linkedin"></i></a></li>
								
								 <li class="social-instagram p-20"><a href="#"><i class="fab fa-instagram"></i></a></li>
                               
                            </ul>
                        </div>
					
					
					</div>
					
                    <div class="row">
                        <div class="col-lg-7">
                            <div class="widget">

                                <div class="widget-title"><img src="../../assets/images/logo_footer.png"></div>
                               
                               
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-5 col-md-12">
                            <div class="row">
								
								
                            <!-- Footer widget area 5 -->
                            <div class="widget clearfix widget-newsletter">
                                <h4 class="widget-title"><i class="fa fa-envelope"></i> REGÍSTRATE AHORA</h4>
                                <p>Recibe promociones, descuentos y otros beneficios al registrarte.</p>
								
                                <form class="widget-subscribe-form p-r-40" action="include/subscribe-form.php" role="form" method="post" novalidate="novalidate">


                                    <div class="input-group">
                                        <input aria-required="true" name="widget-subscribe-form-email" class="form-control required email" placeholder="Email" type="email">
                                        <span class="input-group-btn">
                      <button type="submit" id="widget-subscribe-submit-button" class="btn btn-primary"><i class="fa fa-paper-plane"></i></button>
                    </span> </div>
                                </form>
                            </div>
                            <!-- end: Footer widget area 5 -->
                       
                                
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; 2023 Global Certification Academy. Todos los derechos reservados. </div>
                </div>
            </div>
            <a href="https://wa.me/5217222202654?text=Me%20gustaría%20conocer%20el%20más%20de%20las%20certificaciones" class="whatsapp" target="_blank"> <i class="fab fa-whatsapp whatsapp-icon"></i></a>
        </footer>       
</template>

<script>
	export default {
		mounted() {
            const plugin = document.createElement("script");
            plugin.setAttribute(
            "src",
            "../../assets/js/functions.js"
            );
            plugin.async = true;
            document.head.appendChild(plugin);     
        }        
    }
</script>

<style>
	@import '../../assets/css/plugins.css';
	@import '../../assets/css/fonts.css';
	@import '../../assets/css/style.css';
</style>